/* ═══════════════════════════════════════════════════════
   RUTAM™  —  Animations JS  (assets/rutam-animations.js)
   Curtain loader, exosome network, bio canvas, orbital
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ══════════════════════════════════════════
     CURTAIN OPENER
     ══════════════════════════════════════════ */
  (function initCurtain() {
    var curtain = document.getElementById('rutam-curtain');
    if (!curtain) return;

    /* Spawn exosome particles */
    var field = curtain.querySelector('.exo-field');
    if (field) {
      for (var i = 0; i < 20; i++) {
        var p = document.createElement('div');
        var s = 18 + Math.random() * 72;
        p.className = 'exo-particle';
        p.style.cssText = [
          'width:'  + s + 'px',
          'height:' + s + 'px',
          'left:'   + (Math.random() * 100) + '%',
          'top:'    + (Math.random() * 100) + '%',
          'animation-duration:' + (7 + Math.random() * 9) + 's,' + (3 + Math.random() * 4) + 's',
          'animation-delay:' + (-Math.random() * 10) + 's,' + (-Math.random() * 4) + 's'
        ].join(';');
        field.appendChild(p);
      }
    }

    /* Trigger opening after bar fills (~3.1s) */
    setTimeout(function() {
      curtain.classList.add('opening');
      setTimeout(function() {
        curtain.classList.add('fading');
        setTimeout(function() {
          curtain.classList.add('gone');
        }, 450);
      }, 1400);
    }, 3100);
  })();

  /* ══════════════════════════════════════════
     HERO LEFT — exosome network
     ══════════════════════════════════════════ */
  (function initExoNetwork() {
    var c = document.getElementById('exo-canvas');
    if (!c) return;
    var ctx = c.getContext('2d');
    var nodes = [];

    function resize() { c.width = c.offsetWidth; c.height = c.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    for (var i = 0; i < 22; i++) {
      nodes.push({
        x: Math.random() * c.width,  y: Math.random() * c.height,
        r: 2 + Math.random() * 5,
        vx: (Math.random() - .5) * .35, vy: (Math.random() - .5) * .35,
        p: Math.random() * Math.PI * 2, ps: .015 + Math.random() * .02
      });
    }

    function draw() {
      ctx.clearRect(0, 0, c.width, c.height);
      for (var i = 0; i < nodes.length; i++) {
        for (var j = i + 1; j < nodes.length; j++) {
          var dx = nodes[i].x - nodes[j].x, dy = nodes[i].y - nodes[j].y;
          var d = Math.sqrt(dx*dx + dy*dy);
          if (d < 130) {
            ctx.beginPath(); ctx.moveTo(nodes[i].x, nodes[i].y); ctx.lineTo(nodes[j].x, nodes[j].y);
            ctx.strokeStyle = 'rgba(168,184,166,' + (.12 * (1 - d/130)) + ')';
            ctx.lineWidth = .5; ctx.stroke();
          }
        }
      }
      nodes.forEach(function(n) {
        n.p += n.ps;
        var pr = n.r + Math.sin(n.p) * 1.5;
        ctx.beginPath(); ctx.arc(n.x, n.y, pr * 2.8, 0, Math.PI*2);
        ctx.strokeStyle = 'rgba(168,184,166,' + (.07 + .05 * Math.sin(n.p)) + ')'; ctx.lineWidth = .5; ctx.stroke();
        ctx.beginPath(); ctx.arc(n.x, n.y, pr, 0, Math.PI*2);
        ctx.fillStyle = 'rgba(200,207,196,' + (.35 + .22 * Math.sin(n.p)) + ')'; ctx.fill();
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0 || n.x > c.width)  n.vx *= -1;
        if (n.y < 0 || n.y > c.height) n.vy *= -1;
      });
      requestAnimationFrame(draw);
    }
    draw();
  })();

  /* ══════════════════════════════════════════
     HERO RIGHT — exosome cell visualizer
     ══════════════════════════════════════════ */
  (function initBioCanvas() {
    var c = document.getElementById('bio-canvas');
    if (!c) return;
    var ctx = c.getContext('2d'), t = 0;

    function resize() { c.width = c.offsetWidth; c.height = c.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    var exosomes = [];
    for (var i = 0; i < 5; i++) {
      exosomes.push({
        x: .15 + Math.random() * .7, y: .15 + Math.random() * .7,
        r: 28 + Math.random() * 42,
        phase: Math.random() * Math.PI * 2, speed: .004 + Math.random() * .004,
        dx: (Math.random() - .5) * .0006, dy: (Math.random() - .5) * .0006,
        proteins: Math.floor(6 + Math.random() * 8),
        col: i === 0 ? '168,184,166' : i === 1 ? '200,207,196' : '245,242,236'
      });
    }
    var sigs = [];
    for (var j = 0; j < 40; j++) {
      sigs.push({ angle: Math.random() * Math.PI * 2, dist: Math.random() * 180, speed: .3 + Math.random() * .5, r: 1 + Math.random() * 2, op: Math.random() });
    }

    function drawEx(ex, W, H) {
      var cx = ex.x * W, cy = ex.y * H, pu = Math.sin(ex.phase + t * ex.speed), r = ex.r;
      var g = ctx.createRadialGradient(cx, cy, r*.6, cx, cy, r*1.8);
      g.addColorStop(0, 'rgba('+ex.col+',.06)'); g.addColorStop(1, 'rgba('+ex.col+',0)');
      ctx.beginPath(); ctx.arc(cx, cy, r*1.8, 0, Math.PI*2); ctx.fillStyle = g; ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy, r+pu*2, 0, Math.PI*2);
      ctx.strokeStyle = 'rgba('+ex.col+','+(0.3+0.15*pu)+')'; ctx.lineWidth = .8; ctx.stroke();
      for (var p = 0; p < ex.proteins; p++) {
        var a = (p/ex.proteins)*Math.PI*2 + t*ex.speed*.5, pr = r+pu*2;
        ctx.beginPath(); ctx.moveTo(cx+Math.cos(a)*pr, cy+Math.sin(a)*pr);
        ctx.lineTo(cx+Math.cos(a)*(pr+8+pu*2), cy+Math.sin(a)*(pr+8+pu*2));
        ctx.strokeStyle='rgba('+ex.col+',.4)'; ctx.lineWidth=.8; ctx.stroke();
        ctx.beginPath(); ctx.arc(cx+Math.cos(a)*(pr+8+pu*2), cy+Math.sin(a)*(pr+8+pu*2), 2, 0, Math.PI*2);
        ctx.fillStyle='rgba('+ex.col+',.6)'; ctx.fill();
      }
      for (var d = 0; d < 4; d++) {
        var da = (d/4)*Math.PI*2 + t*ex.speed*1.5, dr = r*.35;
        ctx.beginPath(); ctx.arc(cx+Math.cos(da)*dr, cy+Math.sin(da)*dr, 2.5, 0, Math.PI*2);
        ctx.fillStyle='rgba('+ex.col+',.55)'; ctx.fill();
      }
      ex.x += ex.dx; ex.y += ex.dy;
      if (ex.x < .05 || ex.x > .95) ex.dx *= -1;
      if (ex.y < .05 || ex.y > .95) ex.dy *= -1;
    }

    function draw() {
      t += .4; ctx.clearRect(0, 0, c.width, c.height);
      var W = c.width, H = c.height, cx = W/2, cy = H/2;
      var bg = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(W,H)*.6);
      bg.addColorStop(0, 'rgba(168,184,166,.04)'); bg.addColorStop(1, 'rgba(14,14,12,0)');
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
      sigs.forEach(function(s) {
        s.dist += s.speed;
        if (s.dist > 220) { s.dist = 0; s.angle = Math.random()*Math.PI*2; s.op = .8; }
        s.op -= .003;
        ctx.beginPath(); ctx.arc(cx+Math.cos(s.angle)*s.dist, cy+Math.sin(s.angle)*s.dist, s.r, 0, Math.PI*2);
        ctx.fillStyle = 'rgba(168,184,166,' + Math.max(0, s.op*.5) + ')'; ctx.fill();
      });
      exosomes.forEach(function(ex) { drawEx(ex, W, H); });
      var nr = 22 + Math.sin(t*.03)*3;
      var ng = ctx.createRadialGradient(cx, cy, 0, cx, cy, nr);
      ng.addColorStop(0,'rgba(200,207,196,.45)'); ng.addColorStop(1,'rgba(168,184,166,.12)');
      ctx.beginPath(); ctx.arc(cx, cy, nr, 0, Math.PI*2); ctx.fillStyle=ng; ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy, nr, 0, Math.PI*2); ctx.strokeStyle='rgba(200,207,196,.5)'; ctx.lineWidth=.8; ctx.stroke();
      for (var ri=1; ri<=3; ri++) {
        var rr=60*ri+(t*.8%60), al=Math.max(0,.18-ri*.04)*(1-(t*.8%60)/60);
        ctx.beginPath(); ctx.arc(cx, cy, rr, 0, Math.PI*2);
        ctx.strokeStyle='rgba(168,184,166,'+al+')'; ctx.lineWidth=.5; ctx.stroke();
      }
      requestAnimationFrame(draw);
    }
    draw();
  })();

  /* ══════════════════════════════════════════
     EXOSOME DIAGRAM (explainer section)
     ══════════════════════════════════════════ */
  (function initExoDiagram() {
    var c = document.getElementById('exo-diagram-canvas');
    if (!c) return;
    var ctx = c.getContext('2d'), t = 0;
    function resize() { c.width = c.offsetWidth; c.height = c.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, { passive: true });
    function draw() {
      t += .5; ctx.clearRect(0, 0, c.width, c.height);
      var W = c.width, H = c.height, cy = H/2;
      var lx=W*.2, rx=W*.8, ex=W*.5;
      ctx.font='9px DM Sans'; ctx.textAlign='center';
      var lp=Math.sin(t*.04)*4;
      ctx.beginPath(); ctx.ellipse(lx,cy,42+lp,54+lp,-.2,0,Math.PI*2); ctx.strokeStyle='rgba(168,184,166,.25)'; ctx.lineWidth=.8; ctx.stroke();
      ctx.beginPath(); ctx.arc(lx,cy,14,0,Math.PI*2); ctx.fillStyle='rgba(168,184,166,.12)'; ctx.fill();
      ctx.fillStyle='rgba(200,207,196,.5)'; ctx.fillText('SOURCE CELL',lx,cy+78);
      var ep=Math.sin(t*.06)*3, er=32+ep;
      ctx.beginPath(); ctx.arc(ex,cy,er,0,Math.PI*2); ctx.strokeStyle='rgba(200,207,196,.5)'; ctx.lineWidth=1; ctx.stroke();
      for (var p=0;p<10;p++) {
        var pa=(p/10)*Math.PI*2+t*.018;
        ctx.beginPath(); ctx.moveTo(ex+Math.cos(pa)*er,cy+Math.sin(pa)*er); ctx.lineTo(ex+Math.cos(pa)*(er+9+ep),cy+Math.sin(pa)*(er+9+ep));
        ctx.strokeStyle='rgba(200,207,196,.45)'; ctx.lineWidth=.8; ctx.stroke();
        ctx.beginPath(); ctx.arc(ex+Math.cos(pa)*(er+9+ep),cy+Math.sin(pa)*(er+9+ep),2.5,0,Math.PI*2); ctx.fillStyle='rgba(200,207,196,.7)'; ctx.fill();
      }
      for (var d=0;d<5;d++) { var da=(d/5)*Math.PI*2+t*.03; ctx.beginPath(); ctx.arc(ex+Math.cos(da)*14,cy+Math.sin(da)*14,3,0,Math.PI*2); ctx.fillStyle='rgba(168,184,166,.6)'; ctx.fill(); }
      ctx.fillStyle='rgba(200,207,196,.5)'; ctx.fillText('RUTAM3X+EXO™',ex,cy+78);
      ctx.font='8px DM Sans'; ctx.fillStyle='rgba(168,184,166,.35)'; ctx.fillText('Precision Delivery Vehicle',ex,cy+92);
      var rp=Math.sin(t*.035+1)*4;
      ctx.beginPath(); ctx.ellipse(rx,cy,38+rp,58+rp,.15,0,Math.PI*2); ctx.strokeStyle='rgba(168,184,166,.25)'; ctx.lineWidth=.8; ctx.stroke();
      ctx.font='9px DM Sans'; ctx.fillStyle='rgba(200,207,196,.5)'; ctx.fillText('FOLLICLE',rx,cy+82);
      var lPr=(t*.8%100)/100;
      for(var k=0;k<4;k++){var kp=(lPr+k*.25)%1;ctx.beginPath();ctx.arc(lx+(ex-lx-50)*kp,cy+Math.sin(kp*Math.PI)*-12,2.5,0,Math.PI*2);ctx.fillStyle='rgba(168,184,166,'+(0.15+kp*.5)+')';ctx.fill();}
      var rPr=(t*.7%100)/100;
      for(var m=0;m<4;m++){var mp=(rPr+m*.25)%1;ctx.beginPath();ctx.arc(ex+36+(rx-ex-46)*mp,cy+Math.sin(mp*Math.PI)*-12,2.5,0,Math.PI*2);ctx.fillStyle='rgba(200,207,196,'+(0.15+mp*.5)+')';ctx.fill();}
      ctx.setLineDash([3,5]);
      ctx.beginPath();ctx.moveTo(lx+44,cy);ctx.lineTo(ex-34,cy);ctx.strokeStyle='rgba(168,184,166,.12)';ctx.lineWidth=.5;ctx.stroke();
      ctx.beginPath();ctx.moveTo(ex+34,cy);ctx.lineTo(rx-40,cy);ctx.stroke();
      ctx.setLineDash([]);
      requestAnimationFrame(draw);
    }
    draw();
  })();

  /* ══════════════════════════════════════════
     MINI EXOSOME icons
     ══════════════════════════════════════════ */
  document.querySelectorAll('.mini-exo').forEach(function(c) {
    c.width = 64; c.height = 64;
    var ctx = c.getContext('2d');
    var col = c.getAttribute('data-color') || '168,184,166';
    var t = Math.random() * 100;
    function draw() {
      t += .5; ctx.clearRect(0,0,64,64);
      var pu=Math.sin(t*.05)*2, r=18+pu;
      var g=ctx.createRadialGradient(32,32,0,32,32,32);
      g.addColorStop(0,'rgba('+col+',.12)'); g.addColorStop(1,'rgba('+col+',0)');
      ctx.fillStyle=g; ctx.fillRect(0,0,64,64);
      ctx.beginPath();ctx.arc(32,32,r,0,Math.PI*2);ctx.strokeStyle='rgba('+col+',.45)';ctx.lineWidth=.8;ctx.stroke();
      for(var p=0;p<8;p++){var a=(p/8)*Math.PI*2+t*.02;ctx.beginPath();ctx.moveTo(32+Math.cos(a)*r,32+Math.sin(a)*r);ctx.lineTo(32+Math.cos(a)*(r+6),32+Math.sin(a)*(r+6));ctx.strokeStyle='rgba('+col+',.4)';ctx.lineWidth=.8;ctx.stroke();ctx.beginPath();ctx.arc(32+Math.cos(a)*(r+6),32+Math.sin(a)*(r+6),1.5,0,Math.PI*2);ctx.fillStyle='rgba('+col+',.6)';ctx.fill();}
      ctx.beginPath();ctx.arc(32,32,7,0,Math.PI*2);ctx.fillStyle='rgba('+col+',.18)';ctx.fill();
      requestAnimationFrame(draw);
    }
    draw();
  });

  /* ══════════════════════════════════════════
     ORBITAL SCIENCE CANVAS
     ══════════════════════════════════════════ */
  (function initOrbital() {
    var c = document.getElementById('orbital-canvas');
    if (!c) return;
    var ctx = c.getContext('2d'), t = 0;
    function resize() { c.width = c.offsetWidth; c.height = c.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, { passive: true });
    var orbits = [
      {r:160,speed:.008, nodes:3,col:'168,184,166',nr:8},
      {r:110,speed:-.013,nodes:2,col:'200,207,196',nr:6},
      {r:65, speed:.022, nodes:4,col:'245,242,236',nr:4}
    ];
    function draw() {
      t += .5; ctx.clearRect(0,0,c.width,c.height);
      var W=c.width,H=c.height,cx=W/2,cy=H/2;
      var bg=ctx.createRadialGradient(cx,cy,0,cx,cy,200);
      bg.addColorStop(0,'rgba(168,184,166,.04)');bg.addColorStop(1,'rgba(14,14,12,0)');
      ctx.fillStyle=bg;ctx.fillRect(0,0,W,H);
      orbits.forEach(function(orb){ctx.beginPath();ctx.arc(cx,cy,orb.r,0,Math.PI*2);ctx.strokeStyle='rgba(168,184,166,.1)';ctx.lineWidth=.5;ctx.stroke();});
      orbits.forEach(function(orb){
        for(var n=0;n<orb.nodes;n++){
          var angle=(n/orb.nodes)*Math.PI*2+t*orb.speed,nx=cx+Math.cos(angle)*orb.r,ny=cy+Math.sin(angle)*orb.r,pu=Math.sin(t*.04+n)*1.5;
          var ng=ctx.createRadialGradient(nx,ny,0,nx,ny,orb.nr*2.5);ng.addColorStop(0,'rgba('+orb.col+',.2)');ng.addColorStop(1,'rgba('+orb.col+',0)');ctx.fillStyle=ng;ctx.beginPath();ctx.arc(nx,ny,orb.nr*2.5,0,Math.PI*2);ctx.fill();
          ctx.beginPath();ctx.arc(nx,ny,orb.nr+pu,0,Math.PI*2);ctx.strokeStyle='rgba('+orb.col+',.45)';ctx.lineWidth=.8;ctx.stroke();
          for(var sp=0;sp<5;sp++){var sa=(sp/5)*Math.PI*2+angle,sr=orb.nr+pu;ctx.beginPath();ctx.moveTo(nx+Math.cos(sa)*sr,ny+Math.sin(sa)*sr);ctx.lineTo(nx+Math.cos(sa)*(sr+4),ny+Math.sin(sa)*(sr+4));ctx.strokeStyle='rgba('+orb.col+',.35)';ctx.lineWidth=.6;ctx.stroke();}
        }
      });
      var nr=30+Math.sin(t*.025)*4,cg=ctx.createRadialGradient(cx,cy,0,cx,cy,nr);
      cg.addColorStop(0,'rgba(200,207,196,.35)');cg.addColorStop(1,'rgba(168,184,166,.06)');
      ctx.beginPath();ctx.arc(cx,cy,nr,0,Math.PI*2);ctx.fillStyle=cg;ctx.fill();
      ctx.beginPath();ctx.arc(cx,cy,nr,0,Math.PI*2);ctx.strokeStyle='rgba(200,207,196,.4)';ctx.lineWidth=.8;ctx.stroke();
      var pb=t*.6%80;
      for(var ri=0;ri<3;ri++){var pr=pb+ri*27,pa=Math.max(0,.2-pr/80*.2);ctx.beginPath();ctx.arc(cx,cy,pr+nr,0,Math.PI*2);ctx.strokeStyle='rgba(168,184,166,'+pa+')';ctx.lineWidth=.5;ctx.stroke();}
      ctx.font='500 11px DM Sans';ctx.textAlign='center';ctx.fillStyle='rgba(200,207,196,.55)';ctx.fillText('RUTAM3X+EXO™',cx,cy+4);
      ctx.font='9px DM Sans';ctx.fillStyle='rgba(168,184,166,.3)';ctx.fillText('Bio-Signaling System',cx,cy+20);
      requestAnimationFrame(draw);
    }
    draw();
  })();

})();